import React from "react";
import "../pages/LandingPage.css";
import logo from "../../assets/numbai-tak.png";

export default function Tab({ currentTab, setCurrentTab, openInNewTab }) {
  return (
    <>
      <div className="logoSection">
        <img src={logo} alt="banner" className="logoImage" />
      </div>
      <div className="tabSection">
        <div
          className="tab"
          onClick={() => openInNewTab("https://www.youtube.com/c/MumbaiTak")}
        >
          होम
        </div>
        {/* <div
          className={`tab ${currentTab === "procedure" ? "activeTab" : ""}`}
          onClick={() => setCurrentTab("procedure")}
        >
          भाग लेने के लिए
        </div> */}
        <div
          className={`tab ${currentTab === "form" ? "activeTab" : ""}`}
          onClick={() => setCurrentTab("form")}
        >
          रजिस्टर करा
        </div>
        <div
          className={`tab ${currentTab === "rules" ? "activeTab" : ""}`}
          onClick={() => setCurrentTab("rules")}
        >
          नियम व अटी
        </div>
      </div>
    </>
  );
}
